/* eslint-disable max-lines */
import type { Space } from '@mail/cross-sizes-utils';
import type { DemoPromoTooltipVariant } from 'reactApp/appHelpers/featuresHelpers/features/demoPromo';
import type { MobileAppPromoType } from 'reactApp/modules/promo/promoMobileApp/promoMobileApp.types';
import type { EpubPromoType } from 'reactApp/modules/promo/sagas/epub.saga';
import type { VKIDInfo, VkMusicBundleTariffInfo } from 'reactApp/modules/vkMusic/vkMusic.types';
import type { Product, Tariff } from 'reactApp/types/Billing';

export enum EPromoType {
    bindingSpherum = 'bindingSpherum',
    topBanner = 'topBanner',
    whatsNew = 'whatsNew',
    faceFilter = 'faceFilter',
    mobilePublicBanner = 'mobilePublicBanner',
    mobileSearchBanner = 'mobileSearchBanner',
    mobileSearchHistoryBanner = 'mobileSearchHistoryBanner',
    secondClick = 'secondClick',
    banner = 'banner',
    overQuota = 'overQuota',
    quota = 'quota',
    downloadApp = 'downloadApp',
    expiredDeviceSubscription = 'expiredDeviceSubscription',
    publicUpload = 'publicUpload',
    csatSurvey = 'csatSurvey',
    newFeaturesDesktop = 'newFeaturesDesktop',
    newFeaturesMobile = 'newFeaturesMobile',
    diskOAsidePromo = 'diskOAsidePromo',
    safetyAsidePromo = 'safetyAsidePromo',
    // tempexp_SRCH-70119-next-line
    searchTooltip = 'searchTooltip',
    searchFilterTooltipPromo = 'searchFilterTooltipPromo',
    defaultQuotaAsidePromo = 'defaultQuotaAsidePromo',
    autosave = 'autosave',
    epubPromo = 'epubPromo',
    suggestionsLaw = 'suggestionsLaw',
    coEditPopup = 'co-edit-share-popup',
    editorLLMButton = 'tooltip-llm-button',
    familyAsidePromo = 'familyAsidePromo',
    mobileAppPromo = 'mobileAppPromo',
    autologin = 'autologin',
    sidebarTrialPromo = 'sidebarTrialPromo',
    mailspaceTrialPromo = 'mailspaceTrialPromo',
    // tempexp_17086-next-line
    defaultTariffFork = 'defaultTariffFork',
    // tempexp_17340-next-line
    changePublicDesign = 'changePublicDesign',
    themeAsidePromo = 'themeAsidePromo',
    rebranding = 'rebranding',
    // tempexp_17532-next-line
    litresModal = 'litresModal',
    // tempexp_17439-next-line
    referralProgramPromo = 'referralProgramPromo',
    // tempexp_17846-next-line
    themedPublicPromo = 'themedPublicPromo',
    // tempexp_17821-next-line
    autumnPromo = 'autumnPromo',
    allAttaches = 'allAttaches',
    // tempexp_17905-next-line
    restoreTrashbinFiles = 'restoreTrashbinFiles',
    // tempexp_18023-next-line
    pdfWorkWithPagesPromo = 'pdfWorkWithPagesPromo',
    // tempexp_18060-next-line
    blackFriday2024 = 'blackFriday2024',
    // tempexp_18085-next-line
    usedSpacePostpaid = 'usedSpacePostpaid',
    demoPromoTooltip = 'demoPromoTooltip',
    // tempexp_18335-next-line
    gamerBundle = 'gamerBundle',
    // tempexp_18474-next-line
    cyberMonday2025 = 'cyberMonday2025',
    /** 3promo плашки */
    threePromo = '3promo',
    // tempexp_18683-next-line
    flexibleQuotaPromo = 'flexibleQuotaPromo',
    // tempexp_18089-next-line
    partnersDiscount = 'partnersDiscount',
    // tempexp_18455-next-line
    tariffSelectionPoll = 'tariffSelectionPoll',
    // tempexp_18696-next-line
    coverageCampaign = 'coverageCampaign',
    // tempexp_18708-next-line
    autoUpload = 'autoUpload',
    // tempexp_18851-next-line
    paidUserReturn = 'paidUserReturn',
    extendQuotaOfferModal = 'extendQuotaOfferModal',
    editDocumentsInAttachesTooltip = 'editDocumentsInAttachesTooltip',
    // tempexp_18855-next-line
    crossPromoVkMusicFakedoor = 'crossPromoVkMusicFakedoor',
    // tempexp_18828-next-line
    aiSetAb = 'aiSetAb',
    // tempexp_17847-next-line
    downloadLimit = 'downloadLimit',
    // tempexp_18907-next-line
    discountInOutflowLastDayPromo = 'discountInOutflowLastDayPromo',
    // tempexp_18086-next-line
    referralProgramAsidePromo = 'referralProgramAsidePromo',
    // tempexp_18086-next-line
    referralProgramSpacePromo = 'referralProgramSpacePromo',
    // tempexp_18926-next-line
    autoUploadOnboarding = 'autoUploadOnboarding',
    fullScreenCloud = 'fullScreenCloud,',

    showFamilyAlbumsTooltip = 'showFamilyAlbumsTooltip',
    showFamilyAsideMenuTooltip = 'showFamilyAsideMenuTooltip',
    showFamilyDocumentsTooltip = 'showFamilyDocumentsTooltip',
    showFamilyBuyModal = 'showFamilyBuyModal',
    vkMusicBundle = 'vkMusicBundle',
    // tempexp_19124-next-line
    preOverquotaPromo = 'preOverquotaPromo',
    // tempexp_19236-next-line
    subscribedToVigboModal = 'subscribedToVigboModal',
    // tempexp_19213-next-line
    linkVigboAccountTooltip = 'linkVigboAccountTooltip',
    showVigboBuyModal = 'showVigboBuyModal',
    beautifulAddressModal = 'beautifulAddressModal',
    vigboRenewRemind = 'vigboRenewRemind',
    vigboTariffEnd = 'vigboTariffEnd',
}

export interface IBaseData {
    promoId: string;
    forceTopmost?: boolean;

    onShow();

    onClose();
}

export interface IWhatsNewData extends IBaseData {
    onClick();

    onSecondary();

    title: string;
    text: string;
    imageUrl: string;
    date?: number;
    primaryButtonText: string;
    primaryButtonHref?: string;
    primaryButtonTargetBlank?: boolean;
    secondaryButtonText?: string;
    secondaryButtonHref?: string;
    secondaryButtonTargetBlank?: boolean;
    closeAfterClick?: boolean;
    closeBySecondaryButton?: boolean;
    closeIconClassName?: string;
}

export interface ITheme {
    imageUrl: string;
    titleColor: string;
    textColor: string;
    adInfoColor: string;
    primaryButtonColor: string;
    primaryButtonColorHover: string;
    primaryTextButtonColor: string;
    secondaryButtonColor: string;
    secondaryButtonHoverColor: string;
    secondaryTextButtonColor: string;
    crossColor: string;
}

export interface IAdChoice {
    link: { name: string; value: string };
    title: string;
    copy: { name: string; value: string };
}

export interface IWhatsNewRedesignData extends IBaseData {
    onClick: () => void;

    onSecondary: () => void;

    bannerId: number;
    slotId: number;
    campaignId: number;
    campaignName: string;

    title: string;
    text: string;
    primaryButtonText: string;
    primaryButtonHref: string;
    primaryButtonTargetBlank: boolean;
    secondaryButtonText: string;
    secondaryButtonHref: string;
    secondaryButtonTargetBlank: boolean;
    closeBySecondaryButton?: boolean;
    adInfo: string;
    lightTheme: ITheme;
    darkTheme: ITheme;
    adchoice: IAdChoice;
    hideRbRadar?: boolean;
}

type IPromoDataWhatsNew = {
    type: EPromoType.whatsNew;
    templateType?: string;
} & (IWhatsNewData | IWhatsNewRedesignData);

type IPromoFaceFilter = {
    type: EPromoType.faceFilter;
} & IBaseData;

type IPromoMobileSearchBanner = {
    type: EPromoType.mobileSearchBanner;
} & IBaseData;

type IPromoMobileSearchHistoryBanner = {
    type: EPromoType.mobileSearchHistoryBanner;
} & IBaseData;

type IPromoMobilePublicBanner = {
    type: EPromoType.mobilePublicBanner;
} & IBaseData;

export type IPromoSecondClick = {
    type: EPromoType.secondClick;
    onHide();
} & IBaseData;

export type ISidebarTrialPromo = {
    type: EPromoType.sidebarTrialPromo;
    onClick: () => void;
} & IBaseData;

export interface ISpacePromoConfig {
    id: string;
    icon: string;
    title: string;
    text: string;
    button: string;
    tariffId: string;
    features: string[];
}

export type IPromoBanner = {
    type: EPromoType.banner;
    config: ISpacePromoConfig;
    product: Product;
    onClick?: () => void;
} & IBaseData;

export type IPromoOverQuota = {
    type: EPromoType.overQuota;
    tariff?: Tariff;
    product?: Product;
} & IBaseData;

export type IPromoQuota = {
    type: EPromoType.quota;
    quota: number;
} & IBaseData;

export type IPromoDownloadApp = {
    type: EPromoType.downloadApp;
} & IBaseData;

export type IPromoExpiredDeviceSubscription = {
    type: EPromoType.expiredDeviceSubscription;
    product: Tariff;
} & IBaseData;

export type IPromoCSAT = {
    type: EPromoType.csatSurvey;
} & IBaseData;

export type IPromoPublicUpload = {
    type: EPromoType.publicUpload;
} & IBaseData;

type TSearchTooltip = {
    type: EPromoType.searchTooltip;
} & IBaseData;

type TSearchFilterTooltip = {
    type: EPromoType.searchFilterTooltipPromo;
} & IBaseData;

type TPromoNewFeatures = {
    type: EPromoType.newFeaturesDesktop;
} & IBaseData;

type TPromoNewFeaturesMobile = {
    type: EPromoType.newFeaturesMobile;
} & IBaseData;

export interface IDiskOAsidePromoModal extends IBaseData {
    type: EPromoType.diskOAsidePromo;
    onClick: () => void;
}

export interface ISafetyAsidePromoModal extends IBaseData {
    type: EPromoType.safetyAsidePromo;
    onClick: () => void;
}

export interface IBindingSpherumPromoModal extends IBaseData {
    type: EPromoType.bindingSpherum;
}

export interface IAutosaveAsidePromoModal extends IBaseData {
    type: EPromoType.autosave;
}

export type IPromoEpub = {
    type: EPromoType.epubPromo;
    tipType: EpubPromoType[];
    onMarkShown(type: EpubPromoType): void;
} & IBaseData;

export type IPromoSuggestionsLaw = {
    type: EPromoType.suggestionsLaw;
} & IBaseData;

export type IPromoCoEditPopup = {
    type: EPromoType.coEditPopup;
} & IBaseData;

export type IPromoEditorLLMButton = {
    type: EPromoType.editorLLMButton;
} & IBaseData;

export type IPromoAutologin = {
    type: EPromoType.autologin;
} & IBaseData;

export type IMailSpaceTrialPromo = {
    type: EPromoType.mailspaceTrialPromo;
    onClick: () => void;
} & IBaseData;

export interface IFamilyAsidePromoModal extends IBaseData {
    type: EPromoType.familyAsidePromo;
    onClick: () => void;
}

export type PromoMobileApp = {
    type: EPromoType.mobileAppPromo;
    tipType: MobileAppPromoType[];
    onMarkShown(type: MobileAppPromoType): void;
} & IBaseData;

export interface fullScreenCloudType extends IBaseData {
    type: EPromoType.fullScreenCloud;
}

// tempexp_17846-start
export interface IThemedPublicPromoModal extends IBaseData {
    type: EPromoType.themedPublicPromo;
    onClick: () => void;
}

// tempexp_17846-end

// texmpexp_17088-start
export interface IDefaultTariffFork extends IBaseData {
    type: EPromoType.defaultTariffFork;
    product: Product;
}

// tempexp_17340-start
export interface IChangePublicDesign extends IBaseData {
    type: EPromoType.changePublicDesign;
}

// tempexp_17340-end

export interface IDownloadLimit extends IBaseData {
    type: EPromoType.downloadLimit;
}

interface ThemePromoAsideModal extends IBaseData {
    type: EPromoType.themeAsidePromo;
    onClick: () => void;
}

export interface IRebranding extends IBaseData {
    type: EPromoType.rebranding;

    onDone();
}

// tempexp_17532-start
export interface LitresPromoModal extends IBaseData {
    type: EPromoType.litresModal;
    onClick: () => void;
    onCancel: () => void;
}

// tempexp_17532-end

// tempexp_17439-start
export interface ReferralProgramPromoModal extends IBaseData {
    type: EPromoType.referralProgramPromo;
    onClick: () => void;
}

// tempexp_17439-end

// tempexp_17821-start
export interface AutumnPromoModal extends IBaseData {
    type: EPromoType.autumnPromo;
    onClick: () => void;
}

// tempexp_17821-end
export interface AllAttachesTip extends IBaseData {
    type: EPromoType.allAttaches;
}

// tempexp_17905-start
export interface RestoreTrashbinFilesModal extends IBaseData {
    type: EPromoType.restoreTrashbinFiles;
    onClick: () => void;
    onSecondary: () => void;
}

// tempexp_17905-end

// tempexp_18023-start
export type IPdfWorkWithPagesPromo = {
    type: EPromoType.pdfWorkWithPagesPromo;
} & IBaseData;
// tempexp_18023-end

// tempexp_18060-start
export interface BlackFriday2024Modal extends IBaseData {
    type: EPromoType.blackFriday2024;
    onClick: () => void;
}

// tempexp_18060-end

// tempexp_18085-start
export interface UsedSpacePostpaidModal extends IBaseData {
    type: EPromoType.usedSpacePostpaid;
    onClick: () => void;
    onSecondary: () => void;
}

// tempexp_18085-end

export type DemoPromoTooltipData = IBaseData & {
    type: EPromoType.demoPromoTooltip;
    variant: DemoPromoTooltipVariant;
};

// tempexp_18335-start
export interface GamerBundleModal extends IBaseData {
    type: EPromoType.gamerBundle;
    onClick: () => void;
}

// tempexp_18335-end
// tempexp_18474-start
export interface CyberMonday2025Modal extends IBaseData {
    type: EPromoType.cyberMonday2025;
    onClick: () => void;
}

// tempexp_18474-end

export interface PromoFD extends IBaseData {
    type: EPromoType.threePromo;
}

// tempexp_18683-start
export interface IFlexibleQuotaPromo extends IBaseData {
    type: EPromoType.flexibleQuotaPromo;
    onClick: () => void;
}

// tempexp_18683-end

// tempexp_18089-start
interface PartnersFakedoorAsidePromoModal extends IBaseData {
    type: EPromoType.partnersDiscount;
    onClick: () => void;
}

// tempexp_18089-end

// tempexp_18455-next-line
interface TariffSelectionPoll extends IBaseData {
    type: EPromoType.tariffSelectionPoll;
}

// tempexp_18696-start
interface CoverageCampaignAsidePromoModal extends IBaseData {
    type: EPromoType.coverageCampaign;
    onClick: () => void;
}

// tempexp_18696-end

// tempexp_18708-start
export interface AutoUploadPromoModal extends IBaseData {
    type: EPromoType.autoUpload;
    onClick: () => void;
}

interface EditTooltipData extends IBaseData {
    type: EPromoType.editDocumentsInAttachesTooltip;
    onClick: () => void;
    onEditDisabled: () => void;
    onCrossClose: () => void;
}

interface FamilyAlbumsTooltip extends IBaseData {
    type: EPromoType.showFamilyAlbumsTooltip;
    onClick: () => void;
    onClose: () => void;
    onCrossClose: () => void;
}

interface FamilyAsideMenuTooltip extends IBaseData {
    type: EPromoType.showFamilyAsideMenuTooltip;
    onClick: () => void;
    onClose: () => void;
    onCrossClose: () => void;
}

interface FamilyDocumentsTooltip extends IBaseData {
    type: EPromoType.showFamilyDocumentsTooltip;
    onClick: () => void;
    onClose: () => void;
    onCrossClose: () => void;
}

interface FamilyBuyModal extends IBaseData {
    type: EPromoType.showFamilyBuyModal;
    isMobile: boolean;
    onShow: () => void;
    onPrimaryClick: () => void;
    onSecondaryClick: () => void;
    onClose: () => void;
}

// tempexp_18708-end

// tempexp_18851-start
interface PaidUserReturnModal extends IBaseData {
    type: EPromoType.paidUserReturn;
    onClick: () => void;
}

// tempexp_18851-end

interface ExtendQuotaOfferModal extends IBaseData {
    type: EPromoType.extendQuotaOfferModal;
    onPrimaryClick: () => void;
    onSecondaryClick: () => void;
    onCancel?: () => void;
}

// tempexp_18855-start
export interface CrossPromoVkMusicFakedoorModal extends IBaseData {
    type: EPromoType.crossPromoVkMusicFakedoor;
    onClick: () => void;
    onSecondary: () => void;
    price: number;
}

// tempexp_18855-end

// tempexp_18086-start
export interface ReferralProgramAsideModal extends IBaseData {
    type: EPromoType.referralProgramAsidePromo;
    onClick: () => void;
}

export interface ReferralProgramSpaceModal extends IBaseData {
    type: EPromoType.referralProgramSpacePromo;
    onClick: () => void;
}

// tempexp_18086-end

// tempexp_18828-start
interface AiSetFakedoorPromoModal extends IBaseData {
    type: EPromoType.aiSetAb;
    onClick: () => void;
    onDismiss: () => void;
}

// tempexp_18828-end

// tempexp_18907-start

interface DiscountInOutflowLastDayPromo extends IBaseData {
    type: EPromoType.discountInOutflowLastDayPromo;
    subId: number;
}

// tempexp_18907-end

// tempexp_18926-start
interface AutoUploadOnboardingPromoModal extends IBaseData {
    type: EPromoType.autoUploadOnboarding;
    onClick: () => void;
}

interface BeautifulAddressModal extends IBaseData {
    type: EPromoType.beautifulAddressModal;
}

// tempexp_18926-end

interface VkMusicBundleModal extends IBaseData {
    type: EPromoType.vkMusicBundle;
    onClick: () => void;
    tariffInfo: VkMusicBundleTariffInfo;
    vkid?: VKIDInfo;
}

interface PreOverquotaPromoModal extends IBaseData {
    type: EPromoType.preOverquotaPromo;
    onClick: () => void;
    onSecondaryClick: () => void;
    onDismiss: () => void;
    primaryButtonText: string;
    secondaryButtonText: string;
}

// tempexp_19236-start
type ISubscribedToVigboModal = {
    type: EPromoType.subscribedToVigboModal;
    onClick?: () => void;
} & IBaseData;

// tempexp_19236-end
// tempexp_19213-start
type ILinkVigboAccountTooltip = {
    type: EPromoType.linkVigboAccountTooltip;
    onClick: () => void;
    onCrossClose: () => void;
} & IBaseData;

// tempexp_19213-end

type IVigboBuyModal = {
    type: EPromoType.showVigboBuyModal;
    onClick: () => void;
    onClose: () => void;
} & IBaseData;

interface VigboRenewRemind extends IBaseData {
    type: EPromoType.vigboRenewRemind;
    expireDate: number;
    tariffSpace: Space;

    onClick: () => void;
}

interface VigboTariffEnd extends IBaseData {
    type: EPromoType.vigboTariffEnd;
    isOverquota: boolean;
    product: Product;

    onClick: () => void;
}

export type IPromoData =
    | IPromoDataWhatsNew
    | IPromoFaceFilter
    | IPromoMobileSearchBanner
    | IPromoMobileSearchHistoryBanner
    | IPromoMobilePublicBanner
    | IPromoSecondClick
    | IPromoBanner
    | IPromoOverQuota
    | IPromoQuota
    | IPromoDownloadApp
    | IPromoExpiredDeviceSubscription
    | IPromoCSAT
    | IPromoPublicUpload
    | TPromoNewFeatures
    | TPromoNewFeaturesMobile
    | TSearchTooltip
    | TSearchFilterTooltip
    | IDiskOAsidePromoModal
    | ISafetyAsidePromoModal
    | IAutosaveAsidePromoModal
    | IPromoEpub
    | IFamilyAsidePromoModal
    | IBindingSpherumPromoModal
    | IPromoSuggestionsLaw
    | IPromoCoEditPopup
    | IPromoEditorLLMButton
    | PromoMobileApp
    | IPromoAutologin
    | ISidebarTrialPromo
    | IMailSpaceTrialPromo
    // texmpexp_17088-next-line
    | IDefaultTariffFork
    // tempexp_17340-next-line
    | IChangePublicDesign
    | ThemePromoAsideModal
    | IRebranding
    // tempexp_17532-next-line
    | LitresPromoModal
    // tempexp_17439-next-line
    | ReferralProgramPromoModal
    | IDownloadLimit
    // tempexp_17846-next-line
    | IThemedPublicPromoModal
    // tempexp_17821-next-line
    | AutumnPromoModal
    | AllAttachesTip
    // tempexp_17905-next-line
    | RestoreTrashbinFilesModal
    // tempexp_18023-next-line
    | IPdfWorkWithPagesPromo
    // tempexp_18060-next-line
    | BlackFriday2024Modal
    // tempexp_18085-next-line
    | UsedSpacePostpaidModal
    // tempexp_18683-next-line
    | IFlexibleQuotaPromo
    | DemoPromoTooltipData
    | GamerBundleModal
    | CyberMonday2025Modal
    | PromoFD
    // tempexp_18089-next-line
    | PartnersFakedoorAsidePromoModal
    // tempexp_18455-next-line
    | TariffSelectionPoll
    // tempexp_18696-next-line
    | CoverageCampaignAsidePromoModal
    // tempexp_18708-next-line
    | AutoUploadPromoModal
    | EditTooltipData
    | CrossPromoVkMusicFakedoorModal
    // tempexp_18851-next-line
    | PaidUserReturnModal
    // tempexp_18828-next-line
    | AiSetFakedoorPromoModal
    | ExtendQuotaOfferModal
    // tempexp_18907-next-line
    | DiscountInOutflowLastDayPromo
    // tempexp_18086-next-line
    | ReferralProgramAsideModal
    // tempexp_18086-next-line
    | ReferralProgramSpaceModal
    // tempexp_18926-next-line
    | AutoUploadOnboardingPromoModal
    | fullScreenCloudType
    | FamilyAsideMenuTooltip
    | FamilyAlbumsTooltip
    | FamilyDocumentsTooltip
    | FamilyBuyModal
    | VkMusicBundleModal
    | VkMusicBundleModal
    | PreOverquotaPromoModal
    // tempexp_19236-next-line
    | ISubscribedToVigboModal
    // tempexp_19213-next-line
    | ILinkVigboAccountTooltip
    | IVigboBuyModal
    | BeautifulAddressModal
    | VigboRenewRemind
    | VigboTariffEnd;

export type IGenericPromoData<T extends EPromoType> = {
    type: T;
} & IPromoData;

export function isNeedsPromo<T extends EPromoType>(promoType: T, promo?: IPromoData): promo is IGenericPromoData<T> {
    return promo?.type === promoType;
}

export interface IPromoState {
    queue: IPromoData[];
    currentPromo?: IPromoData;
    lastPromoShownTimestamp?: Date;
    threePromoShown: boolean;
}
